var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22C6.977 22 2.5 17.523 2.5 12H4.5C4.5 16.418 8.082 20 12.5 20C16.918 20 20.5 16.418 20.5 12C20.5 7.582 16.918 4 12.5 4C10.036 4 7.832 5.114 6.365 6.865L8.5 9H2.5V3L4.947 5.446C6.78 3.336 9.484 2 12.5 2ZM13.5 7V11.585L16.743 14.828L15.328 16.243L11.5 12.413V7H13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletcircle);
export default __webpack_public_path__ + "static/media/walletcircle.3633ec3c50b6f642fdef50c41cf8a453.svg";
export { ForwardRef as ReactComponent };